import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  TagPicker,
  TagPickerList,
  TagPickerControl,
  TagPickerInput,
  TagPickerOption,
  TagPickerGroup,
  Tag,
  Tooltip,
  Button,
} from "@fluentui/react-components";
import { FluentField } from "./Fluent-Field";
import FluentUiIcon from "../../assets/fluent-ui-icon";

export const FluentTagPicker = ({
  options,
  selectedOptions: parentSelectedOptions,
  onOptionSelect,
  placeholder,
  label,
  required = false,
}) => {
  const [internalSelectedOptions, setInternalSelectedOptions] = useState(
    parentSelectedOptions || []
  );
  useEffect(() => {
    if (parentSelectedOptions) {
      setInternalSelectedOptions(updatedSelectedOptions);
    }
  }, [parentSelectedOptions]);

  const handleOptionSelect = (event, data) => {
    const selectedValue = data.value;

    let updatedSelectedOptions;
    if (
      internalSelectedOptions.some((opt) =>
        typeof opt === "string"
          ? opt === selectedValue
          : opt.Id === selectedValue
      )
    ) {
      updatedSelectedOptions = internalSelectedOptions.filter((opt) =>
        typeof opt === "string"
          ? opt !== selectedValue
          : opt.Id !== selectedValue
      );
    } else {
      const selectedOption = options.find((opt) =>
        typeof opt === "string"
          ? opt === selectedValue
          : opt.Id === selectedValue
      );
      updatedSelectedOptions = [...internalSelectedOptions, selectedOption];
    }

    setInternalSelectedOptions(updatedSelectedOptions);
    onOptionSelect(updatedSelectedOptions);
  };
  const truncateText = (text, maxLength) => {
    return text?.length > maxLength
      ? `${text.substring(0, maxLength)}...`
      : text;
  };

  const handleAllClear = (event) => {
    setInternalSelectedOptions([]);
    onOptionSelect([]);
  };

  const getTagPickerOptions = () => {
    const validOptions = options || []; 
    const validSelectedOptions = internalSelectedOptions || []; 
    
    return validOptions
      .filter(
        (option) =>
          !validSelectedOptions.some((selected) =>
            typeof selected === "string"
              ? selected === option
              : selected.Id === option.Id
          )
      )
      .map((option) => ({
        ...option,
        Name: option?.Active === false ? `${option?.Name} [Inactive]` : option?.Name,
        disabled: option?.Active === false,
      }));
  };
  const updatedSelectedOptions = parentSelectedOptions.map((option) => ({
    ...option,
    Name: option?.Active === false ? `${option?.Name} [Inactive]` : option?.Name,
  }));
  return (
    <div className="fluent-tag-picker-container">
      <FluentField label={label} required={required}>
        <TagPicker
          onOptionSelect={handleOptionSelect}
          selectedOptions={internalSelectedOptions}
        >
        <TagPickerControl
          secondaryAction={
            internalSelectedOptions.length > 0 && (
              <Button
                appearance="transparent"
                size="small"
                shape="rounded"
                style={{ justifyContent: "flex-end", paddingRight: "0px" }}
                onClick={handleAllClear}
              >
                <FluentUiIcon name={"DismissRegular"} size={20} />
              </Button>
            )
          }
        >
          <TagPickerGroup aria-label={label}>
            {internalSelectedOptions.map((option) => (
              <Tooltip
                key={option.Id || option}
                content={typeof option === "string" ? option : option.Name}
              >
                <Tag
                  key={typeof option === "string" ? option : option.Id}
                  value={typeof option === "string" ? option : option.Id}
                  style={{
                    maxWidth: "150px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {truncateText(
                    typeof option === "string" ? option : option.Name,
                    15
                  )}
                </Tag>
              </Tooltip>
            ))}
          </TagPickerGroup>
  
          <TagPickerInput
            aria-label={placeholder}
            placeholder={
              internalSelectedOptions?.length === 0 ? placeholder : ""
            }
          />
        </TagPickerControl>
  
        <TagPickerList>
          {getTagPickerOptions().length > 0
            ? getTagPickerOptions().map((option) => (
                <TagPickerOption
                  value={typeof option === "string" ? option : option.Id}
                  key={typeof option === "string" ? option : option.Id}
                  disabled={option.disabled} 
                >
                  {typeof option === "string" ? option : option.Name}
                </TagPickerOption>
              ))
            : "No options available"}
        </TagPickerList>
      </TagPicker>
    </FluentField>
  </div>
  );
  
};

FluentTagPicker.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        Id: PropTypes.string.isRequired,
        Name: PropTypes.string.isRequired,
      }),
    ])
  ).isRequired,
  selectedOptions: PropTypes.array.isRequired,
  onOptionSelect: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
};

FluentTagPicker.defaultProps = {
  required: false,
};
